import { path } from 'ramda'

const BASE_PATH = ['emoji']

const DATA_PATH = [...BASE_PATH, 'data']
const IS_FETCHING_PATH = [...BASE_PATH, 'isFetching']
const DID_INVALIDATE_PATH = [...BASE_PATH, 'didInvalidate']

export const emojisSelector = path(DATA_PATH)
export const isFetchingSelector = path(IS_FETCHING_PATH)
export const didInvalidateSelector = path(DID_INVALIDATE_PATH)
